import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompFileUploadWrapperCore } from '../core/forms/file-upload/wrapper'
import { CompFileUpload } from './CompFileUpload'

/**
 * CompFileUploadWrapper
 */
const CompFileUploadWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompFileUploadWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompFileUpload {...props} />}
    </CompFileUploadWrapperCore>
  )
}


export default CompFileUploadWrapper